module.exports = __webpack_public_path__ + "img/jft_bg.c197e071.png";